import React from 'react';

const DistributionBarCard = ({
  title,
  subtitle,
  icon,
  items = [],
  getLabel,
  getCount,
  getPercentage,
  getBarClass,
  columns = 1,
  footer = null,
}) => {
  const rows = items.map((item, index) => {
    const label = getLabel(item, index);
    const count = getCount(item, index);
    const percentage = getPercentage(item, index);
    const barClass = getBarClass ? getBarClass(item, index) : 'fi-bar-blue';

    return (
      <div className="fi-bar-row" key={`${label}-${index}`}>
        <div className="fi-bar-label">{label}</div>
        <div className="fi-bar-track">
          <div
            className={`fi-bar-fill ${barClass}`}
            style={{ width: `${Math.max(0, Math.min(100, percentage))}%` }}
          />
        </div>
        <div className="fi-bar-stats">
          {count} <span>({percentage}%)</span>
        </div>
      </div>
    );
  });

  const mid = Math.ceil(rows.length / 2);
  const content =
    columns === 2 ? (
      <div className="fi-bar-columns">
        <div className="fi-bar-column">{rows.slice(0, mid)}</div>
        <div className="fi-bar-column">{rows.slice(mid)}</div>
      </div>
    ) : (
      <div className="fi-bar-list">{rows}</div>
    );

  return (
    <article className="fi-card fi-section-card">
      <header className="fi-section-header">
        {icon ? <span className="fi-section-icon" aria-hidden="true">{icon}</span> : null}
        <h3 className="fi-section-title">
          {title}
          {subtitle ? <span className="fi-section-q"> {subtitle}</span> : null}
        </h3>
      </header>
      {content}
      {footer}
    </article>
  );
};

export default DistributionBarCard;
